import { GSLADefinitionsByMutipleWarehouses, GSLARecommendationsByMutipleWarehouses } from '../types/gslaApi';
import { DEFAULT_WHT } from 'src/types';

export const exportToCSV = (
    gslaData: GSLADefinitionsByMutipleWarehouses | undefined,
    gslaRecommendations: GSLARecommendationsByMutipleWarehouses | undefined,
    productionCapabilityArray: string[],
    selectedHandlingTier: string = DEFAULT_WHT
) => {
    if (!gslaData || !gslaRecommendations) {
        throw new Error('No data available for export');
    }

    // Create CSV header matching the expected upload format
    const csvRows = [`warehouseId,productionCapability,handlingTier,actualGSLA,recommendedGSLA,overrideValue\n`];

    // Get all warehouse IDs
    const allWarehouseIds = new Set([
        ...Object.keys(gslaData.warehouseToGSLAMap),
        ...Object.keys(gslaRecommendations.warehouseToGSLARecommendationMap),
    ]);

    // Generate CSV rows
    Array.from(allWarehouseIds).forEach(warehouseId => {
        const actualGSLAs = gslaData.warehouseToGSLAMap[warehouseId] || [];
        const recommendedGSLAs = gslaRecommendations.warehouseToGSLARecommendationMap[warehouseId] || [];

        productionCapabilityArray.forEach(pc => {
            // Filter by selected handling tier
            const matchingGSLA = actualGSLAs.find(gsla => {
                const matches = gsla.productionCapability === pc && 
                    (gsla.warehouseHandlingTier === selectedHandlingTier || 
                     (!gsla.warehouseHandlingTier && selectedHandlingTier === DEFAULT_WHT));
                return matches;
            });
            
            const recommended = recommendedGSLAs.find(rec => rec.productionCapability === pc)?.gslaInSeconds;

            // Only add row if either actual or recommended GSLA exists
            if (matchingGSLA?.gslaInSeconds !== undefined || recommended !== undefined) {
                csvRows.push(`${warehouseId},${pc},${selectedHandlingTier},${matchingGSLA?.gslaInSeconds ?? ''},${recommended ?? ''},\n`);
            }
        });
    });

    // Create and download CSV file with handling tier in filename
    const csvContent = csvRows.join('');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);

    const tierName = selectedHandlingTier.toLowerCase().replace(/\s+/g, '_');
    const filename = `gsla_data_${tierName}_tier.csv`;
    
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};
